export const vehicleBrandsResource = {
  name: 'Vehicle Brands',
  fields: {
    id: 'ID',
    name: 'Name',
    normalizedName: 'Normalized Name',
    translationEn: 'Name (English)',
    translationZhTw: 'Name (繁體中文)',
    translationZhCn: 'Name (简体中文)',
    modelCount: 'Models',
    createdAt: 'Created',
    updatedAt: 'Updated',
  },
  sections: {
    translations: 'Translations',
  },
  help: {
    normalizedName: 'Lowercase canonical name used for lookup. Cannot be changed after creation.',
  },
  create: {
    title: 'Create Vehicle Brand',
    subtitle: 'Add a new brand to the catalog. Translations populate the picker shown to mobile users.',
  },
  edit: {
    title: 'Edit Vehicle Brand',
  },
  delete: {
    title: 'Delete Vehicle Brand',
    cascadeWarning: 'This brand has %{count} model(s). Deleting it will also delete all of its models. Continue?',
    noModels: 'Are you sure you want to delete this brand?',
  },
  notifications: {
    created: 'Vehicle brand created',
    updated: 'Vehicle brand updated',
  },
  errors: {
    duplicate: 'A brand with this name already exists',
  },
};

export const vehicleBrands = {
  'vehicle-brands': vehicleBrandsResource,
};
